/* Lyro — Editorial Collector | theme.js */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  /* ---------- Recherche (header) ---------- */
  function initSearch() {
    var toggle = document.querySelector('[data-search-toggle]');
    var panel = document.getElementById('lyro-search');
    if (!toggle || !panel) return;

    toggle.addEventListener('click', function () {
      var open = panel.hasAttribute('hidden');
      if (open) {
        panel.removeAttribute('hidden');
        var input = panel.querySelector('input[name="q"]');
        if (input) input.focus();
      } else {
        panel.setAttribute('hidden', '');
      }
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }


  /* ---------- Menu mobile ---------- */
  function initMobileNav() {
    var toggle = document.querySelector('[data-menu-toggle]');
    var nav = document.getElementById('lyro-mobile-nav');
    if (!toggle || !nav) return;
    toggle.addEventListener('click', function () {
      var open = nav.hasAttribute('hidden');
      if (open) nav.removeAttribute('hidden');
      else nav.setAttribute('hidden', '');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* ---------- Connexion : mot de passe oublie ---------- */
  function initRecover() {
    var login = document.getElementById('LoginForm');
    var recover = document.getElementById('RecoverPassword');
    if (!login || !recover) return;
    document.querySelectorAll('[data-toggle-recover]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var showRecover = recover.style.display === 'none';
        recover.style.display = showRecover ? 'block' : 'none';
        login.style.display = showRecover ? 'none' : 'block';
      });
    });
    if (window.location.hash === '#recover') {
      recover.style.display = 'block';
      login.style.display = 'none';
    }
  }

  /* ---------- Tri collection ---------- */
  function initSort() {
    var form = document.querySelector('[data-sort-form]');
    if (!form) return;
    var select = form.querySelector('select[name="sort_by"]');
    if (!select) return;

    select.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  /* ---------- Panier : +/- quantité ---------- */
  function initCartQty() {
    document.querySelectorAll('[data-cart-qty]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var delta = parseInt(btn.getAttribute('data-cart-qty'), 10);
        var input = btn.parentElement.querySelector('input[name="updates[]"]');
        if (!input) return;
        input.value = Math.max(0, (parseInt(input.value, 10) || 0) + delta);
      });
    });
  }

  /* ---------- Page produit : quantité, galerie, variantes ---------- */
  function initProduct() {
    var root = document.querySelector('[data-product-section]');
    if (!root) return;

    // Quantité
    root.querySelectorAll('[data-qty]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var input = document.getElementById('qtyInput');
        if (!input) return;
        var delta = parseInt(btn.getAttribute('data-qty'), 10);
        input.value = Math.max(1, (parseInt(input.value, 10) || 1) + delta);
      });
    });

    // Galerie
    root.querySelectorAll('[data-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var main = document.getElementById('mainProductImage');
        var full = thumb.getAttribute('data-full');
        if (main && full) main.src = full;
      });
    });

    // Variantes
    var dataEl = document.querySelector('[data-variants-json]');
    var idInput = root.querySelector('[data-variant-id]');
    var pills = root.querySelectorAll('[data-option-value]');
    if (!dataEl || !idInput || pills.length === 0) return;

    var variants = [];
    try {
      variants = JSON.parse(dataEl.textContent) || [];
    } catch (e) {
      return; // on garde le variant par défaut rendu côté serveur
    }

    var priceEl = root.querySelector('[data-price]');
    var compareEl = root.querySelector('[data-compare]');
    var stockEl = root.querySelector('[data-stock]');
    var stockText = root.querySelector('[data-stock-text]');
    var addBtn = root.querySelector('[data-add-to-cart]');
    var moneyFormat = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || '';
    var threshold = parseInt(root.getAttribute('data-low-stock') || '20', 10);

    function formatMoney(cents) {
      var value = (cents / 100).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      return moneyFormat === 'EUR' || moneyFormat === '' ? value + ' €' : value + ' ' + moneyFormat;
    }

    function currentSelection() {
      var selected = [];
      root.querySelectorAll('.variant-options').forEach(function (group) {
        var active = group.querySelector('.variant-pill.active');
        selected.push(active ? active.getAttribute('data-value') : null);
      });
      return selected;
    }

    function findVariant(selection) {
      return variants.filter(function (v) {
        return selection.every(function (value, i) {
          return value === null || v.options[i] === value;
        });
      })[0];
    }

    function update() {
      var variant = findVariant(currentSelection());

      if (!variant) {
        idInput.value = '';
        if (addBtn) {
          addBtn.disabled = true;
          addBtn.textContent = 'Indisponible';
        }
        if (stockEl) stockEl.hidden = true;
        return;
      }

      idInput.value = variant.id;

      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = formatMoney(variant.compare_at_price);
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }

      if (addBtn) {
        addBtn.disabled = !variant.available;
        addBtn.textContent = variant.available ? 'Ajouter au panier' : 'Épuisé';
      }

      if (stockEl && stockText) {
        var qty = variant.inventory_quantity;
        var tracked = variant.inventory_management !== null && variant.inventory_management !== undefined;
        if (!variant.available) {
          stockText.textContent = 'Rupture de stock';
          stockEl.hidden = false;
        } else if (tracked && qty > 0 && qty <= threshold) {
          stockText.textContent = 'Stock faible (' + qty + ' unité' + (qty > 1 ? 's' : '') + ')';
          stockEl.hidden = false;
        } else {
          stockEl.hidden = true;
        }
      }

      // URL propre (partage / retour arrière)
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        var group = pill.closest('.variant-options');
        if (!group) return;
        group.querySelectorAll('.variant-pill').forEach(function (p) { p.classList.remove('active'); });
        pill.classList.add('active');
        update();
      });
    });

    // Si aucune pastille active au chargement (variante épuisée par défaut), on n'écrase rien.
    if (root.querySelector('.variant-pill.active')) update();
  }

  /* ---------- Produits liés : recommandations natives Shopify ---------- */
  function initRecommendations() {
    document.querySelectorAll('[data-section-id][data-product-id]').forEach(function (section) {
      var productId = section.getAttribute('data-product-id');
      var sectionId = section.getAttribute('data-section-id');
      var row = section.querySelector('[data-related-row]');
      if (!productId || !sectionId || !row) return;

      // section_id = l'ID de la section dans le template JSON (ici "related"), pas le nom du fichier.
      var url = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root
        : '/';
      url += 'recommendations/products?product_id=' + encodeURIComponent(productId) +
        '&limit=8&intent=related&section_id=' + encodeURIComponent(sectionId);

      fetch(url)
        .then(function (res) {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return res.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-related-row]');
          if (fresh && fresh.children.length > 0) {
            row.innerHTML = fresh.innerHTML;
          }
          // Sinon : le fallback rendu côté serveur reste affiché.
        })
        .catch(function () {
          /* Réseau KO → on garde le fallback serveur. */
        });
    });

    document.querySelectorAll('[data-scroll]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var row = btn.closest('.related, .catalog');
        var target = row && row.querySelector('.scroll-row');
        if (!target) return;
        target.scrollBy({ left: parseInt(btn.getAttribute('data-scroll'), 10), behavior: 'smooth' });
      });
    });
  }

  ready(function () {
    initSearch();
    initMobileNav();
    initRecover();
    initSort();
    initCartQty();
    initProduct();
    initRecommendations();
  });

  // Re-init dans l'éditeur de thème quand une section est rechargée
  document.addEventListener('shopify:section:load', function () {
    initSearch();
    initMobileNav();
    initRecover();
    initSort();
    initCartQty();
    initProduct();
    initRecommendations();
  });
})();
